<app-main-layout
  [clickNext]="onClickNext"
  [clickBack]="onClickBack"
  [activateNextButton$]="nextButtonState.activateNext$"
  >
  <div class="main-heading">
    <h2>Project Details*</h2>
  </div>
  <div class="windows">
    @for (item of windowForms; track item; let i = $index) {
      <div
        class="windows-form"
        [formGroup]="item"
        >
        <div class="form-holder">
          <div class="select-wrapper">
            <div class="form-title">
              <span>Window Style {{(i + 1)}}</span>
              <button class="remove-btn" (click)="removeItem('windows', i)">
                <img src="/assets/icons/trash-2.svg" alt="remove-btn" aria-hidden="true">
              </button>
            </div>
            <ng-select
              #styleSelect
              appearance="outline"
              (change)="onChange($event, item)"
              formControlName="style"
              [clearable]="false"
              bindLabel="name"
              bindValue="id"
              class="state-select"
              [dropdownPosition]="'top'"
              >
              @for (option of stylesList; track option) {
                <ng-option [value]="option.text">{{
                  option.text
                }}</ng-option>
              }
            </ng-select>
            <div class="error-msg">
              @if (
                item.controls['style'].invalid && item.controls['style'].touched
                ) {
                <div
                  >
                  @if (item.controls['style'].errors?.['required']) {
                    <span>{{
                      error_messages.FIELD_REQUIRED
                    }}</span>
                  }
                </div>
              }
            </div>
          </div>
          <app-counter
            class="counter-input"
            [step]="counterStep"
            [min]="counterMinValue"
            [max]="counterMaxValue"
            [initialValue]="item.controls['amount']?.value || counterInitialValue"
            type="windows"
            [small]="true"
            (valueChange)="onCounterValueChange($event, 'windows', item)"
            >
          </app-counter>
        </div>
        <div class="options" formArrayName="options">
          <div class="options-list">
            @for (option of getOptionsObject(item.controls['style'].value)?.itemsList; track option; let i = $index) {
              <app-checkbox
                type="small"
                [formControlName]="i.toString()"
                [label]="option.text"
              ></app-checkbox>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <div class="doors">
    @for (item of doorForms; track item; let i = $index) {
      <div
        class="door-form"
        [formGroup]="item"
        >
        <div class="form-holder">
          <div class="select-wrapper">
            <div class="form-title">
              <span>Door Type {{(i + 1)}}</span>
              <button class="remove-btn" (click)="removeItem('doors', i)">
                <img src="/assets/icons/trash-2.svg" alt="remove-btn" aria-hidden="true">
              </button>
            </div>
            <div class="selection-row">
              <div class="select">
                <ng-select
                  #typeSelect
                  appearance="outline"
                  formControlName="type"
                  (change)="onDoorTypeChange($event, item)"
                  [clearable]="false"
                  bindLabel="name"
                  bindValue="id"
                  class="state-select"
                  [dropdownPosition]="'top'"
                  >
                  @for (type of typesList; track type) {
                    <ng-option [value]="type.name">{{
                      type.name
                    }}</ng-option>
                  }
                </ng-select>
                <div class="error-msg">
                  @if (
                    item.controls['type'].invalid && item.controls['type'].touched
                    ) {
                    <div
                      >
                      @if (item.controls['type'].errors?.['required']) {
                        <span>{{
                          error_messages.FIELD_REQUIRED
                        }}</span>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="select">
                <ng-select
                  #locationSelect
                  appearance="outline"
                  formControlName="location"
                  [clearable]="false"
                  bindLabel="name"
                  bindValue="id"
                  class="state-select"
                  [dropdownPosition]="'top'"
                  >
                  @for (location of locationsList; track location) {
                    <ng-option [value]="location.name">{{
                      location.name
                    }}</ng-option>
                  }
                </ng-select>
                <div class="error-msg">
                  @if (
                    item.controls['location'].invalid && item.controls['location'].touched
                    ) {
                    <div
                      >
                      @if (item.controls['location'].errors?.['required']) {
                        <span>{{
                          error_messages.FIELD_REQUIRED
                        }}</span>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="duplicate">
                <button (click)="duplicate(item)">Duplicate</button>
              </div>
            </div>
            <!-- <div>
            <img
              src="/assets/icons/project-details/door-no-glass-1.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-partial-glass-1.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-full-glass-1.svg"
              alt="add-btn"
              aria-hidden="true"
              />
          </div>
          <div>
            <img
              src="/assets/icons/project-details/door-no-glass-2.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-partial-glass-2.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-full-glass-2.svg"
              alt="add-btn"
              aria-hidden="true"
              />
          </div>
          <div>
            <img
              src="/assets/icons/project-details/door-no-glass-3.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-partial-glass-3.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-full-glass-3.svg"
              alt="add-btn"
              aria-hidden="true"
              />
          </div>
          <div>
            <img
              src="/assets/icons/project-details/door-no-glass-4.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-partial-glass-4.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-full-glass-4.svg"
              alt="add-btn"
              aria-hidden="true"
              />
          </div>
          <div>
            <img
              src="/assets/icons/project-details/door-no-glass-5.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-partial-glass-5.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-full-glass-5.svg"
              alt="add-btn"
              aria-hidden="true"
              />
          </div>
          <div>
            <img
              src="/assets/icons/project-details/door-two-panels-1.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-three-panels-1.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-four-panels-1.svg"
              alt="add-btn"
              aria-hidden="true"
              />
          </div>
          <div>
            <img
              src="/assets/icons/project-details/door-two-panels-2.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-three-panels-2.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-four-panels-2.svg"
              alt="add-btn"
              aria-hidden="true"
              />
          </div>
          <div>
            <img
              src="/assets/icons/project-details/door-two-panels-3.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-three-panels-3.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-four-panels-3.svg"
              alt="add-btn"
              aria-hidden="true"
              />
          </div>
          <div>
            <img
              src="/assets/icons/project-details/door-two-panels-4.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-three-panels-4.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-four-panels-4.svg"
              alt="add-btn"
              aria-hidden="true"
              />
          </div>
          <div>
            <img
              src="/assets/icons/project-details/door-two-panels-5.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-three-panels-5.svg"
              alt="add-btn"
              aria-hidden="true"
              />
            <img
              src="/assets/icons/project-details/door-four-panels-5.svg"
              alt="add-btn"
              aria-hidden="true"
              />
          </div>
          <div>
            <img
              src="/assets/icons/project-details/door-color-1.svg"
              alt="add-btn"
              aria-hidden="true"
              />
          </div> -->
          <!-- <div class="dimensions">
          <app-form-group
            class=""
            id="width"
            type="number"
            label="Width (in)"
            formControlName="width"
            >
          </app-form-group>
          <app-form-group
            id="height"
            type="number"
            label="Height (in)"
            formControlName="height"
            >
          </app-form-group>
        </div> -->
        @if (item.controls['style'].value !== DOOR_STYLES.CUSTOM) {
          <div class="door-colors-styles">
            <div class="color">
              <span class="title">Color:</span>
              <div class="colors">
                @for (color of colors[item.controls['type'].value]; track color) {
                  <button class="item"
                    [ngClass]="{'active': item.controls['color'].value === color.name}"
                    (click)="switchColor(color, item)">
                    <img [src]="color.path" [alt]="color.name">
                  </button>
                }
              </div>
            </div>
            <div class="door-styles-list">
              @for (style of item.controls['type'].value === DOOR_TYPES.SLIDING ? slidingStyles[item.controls['color'].value] : styles[item.controls['color'].value]; track style) {
                <div class="configuration-item">
                  <button class="item"
                    [ngClass]="{'active': item.controls['style'].value === style.name}"
                    (click)="switchStyle(style, item)">
                    <img [src]="style.path" [alt]="style.name">
                  </button>
                  <span class="name">{{style.name}}</span>
                </div>
              }
            </div>
          </div>
        }
        @if (item.controls['style'].value === DOOR_STYLES.CUSTOM) {
          <div class="comments">
            <app-form-group
              label="Comments"
              id="styleComments"
              formControlName="styleComments"
              placeholder="(Optional) Please describe your custom preferences here...."
              [textarea]="true"
              [counter]="3000"
              [small]="true"
              class="d-block"
            ></app-form-group>
          </div>
        }
        <div class="custom-style">
          <app-checkbox
            class="attendance-checkbox"
            formControlName="customStyle"
            label="Custom Style"
          ></app-checkbox>
        </div>
      </div>
    </div>
  </div>
}
</div>
<div class="controls">
  <button class="add-btn" (click)="addItem(itemTypes.WINDOWS)">
    <img
      class="icon"
      src="/assets/icons/add-homeowner.svg"
      alt="add-btn"
      aria-hidden="true"
      />
    Add a window
  </button>
  <button class="add-btn" (click)="addItem(itemTypes.DOORS)">
    <img
      class="icon"
      src="/assets/icons/add-homeowner.svg"
      alt="add-btn"
      aria-hidden="true"
      />
    Add a door
  </button>
</div>
</app-main-layout>
